<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商名称</label>
            <span class="weui-form-preview__value">{{params.vendname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">年份</label>
            <span class="weui-form-preview__value">{{params.year}}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview" v-for="(item, index) in result" :key="index">
        <div class="form-detail-preview_num">{{index + 1}}</div>
        <div class="weui-form-preview__bd form-detail-preview">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">月份</label>
            <span class="weui-form-preview__value">{{item.vm_yearmonth}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{item.vm_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本月应付金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vm_year_pay}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">当前应付余额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vm_end}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本月已付金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vm_paid}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本月未付金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vm_add_pay_remain_nb}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本月入库金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vm_add_pay}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本月预付余额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vm_end_pre}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本月已核金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vm_reduce_pay}}</span>
          </div>
          
          <div class="weui-form-preview__item" v-if="item.bm_id">
            <label class="weui-form-preview__label">对账明细表</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              <router-link :to="'/purchase/apcheck/'+item.bm_id" class="iconfont icon-eye"></router-link>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(!to.params.item)to.params.item = from.params.item || null // 兼容返回到本页
      vm.params.vendid = to.params.item.vy_vendid
      vm.params.vendname = to.params.item.vy_vend_name
      vm.params.year = to.params.item.vy_year
      vm.params.currency = to.params.item.vy_currency
      vm.requestList();
    });
  },
  data() {
    return {
      listUrl: "/api/purchase/purchaseBill/listByMonth",
      params: {
        vendid: null,
        vendname: "",
        year: null,
        currency: "",
        page: 1,
        start: 0,
        limit: 25,        
      },
      result: []
    };
  },
  methods: {
    requestList() {
      var me = this
      me.$loading({
          url: me.listUrl,
          params: me.params
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    vm_endamount(index) {
      return this.result[index].vm_nowamount - this.result[index].vm_nowprepayamount - this.result[index].vm_nowpayamount
    }
  }
}
</script>